import React from "react";
import { useLocation } from "react-router-dom";

export default function ThankYouOptInBidMessage() {
  const location = useLocation();

  return (
    <>
      <div>
        <div className="container-fluid pt-2">
          <div className="row">
            <div
              className="col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12"
              style={{ marginTop: "200px" }}
            >
              <div className="text-center">
                <img
                  src="./assets/img/thank-you.png"
                  className="img-fluid brand-img"
                />
              </div>
            </div>
            <div
              className="row"
              style={{
                height: "20vh",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="text-center">
                <div class="" role="alert">
                  <h1>Thank you!</h1>
                  <p>
                    <h4>
                      Thank you for opting in bid supplier quotation. We will
                      reach out to you shortly.
                    </h4>
                  </p>
                  <button
                    onClick={() => {
                      window.location.href = `/new-supplier-bid?bid=${location?.state?.bidId}&suid=${location?.state?.supplieruId}`;
                    }}
                    className="btn btn-primary go-home-btn"
                  >
                    Go Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
